import { Box, FormControl, MenuItem, Select, InputLabel, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useLocalization } from 'hooks/useLocalization';
import { useBusiness } from 'hooks/useBusiness';
import { useActivityShopUI } from 'hooks/useActivityShopUI';
import { useUI } from 'hooks/useUI';
import { SelectChangeEvent } from '@mui/material/Select';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

function CurrencySelector() {
	const { getStr } = useLocalization();
	const { getBizConfigVar, currencyOptions } = useBusiness();
	const { selectedCurrencyCode, handleCurrencyChange } = useActivityShopUI();
	const { isSizeOrLess } = useUI();
	const businessCurrency = getBizConfigVar('currency');
	
	const isXsApp = isSizeOrLess('xs');
	const isMdApp = isSizeOrLess('md');

	const handleChange = (event: SelectChangeEvent) => {
		handleCurrencyChange(event.target.value);
	};

	return(
		<>
			{
				selectedCurrencyCode !== null ? (
					<Box display="flex" alignItems="center">
						{!isXsApp && <CurrencyExchangeIcon style={{ marginRight: '15px' }} />}
						<FormControl
							sx={{
								'& .MuiSelect-select': {
									padding: '10px 12px', // Adjust the padding inside the Select
								}
							}}
						>
							<InputLabel
								id="select-currency-label"
							>
								{getStr('Currency')}
							</InputLabel>
							<Select
								labelId="select-currency-label"
								id="select-currency"
								value={selectedCurrencyCode}
								label={getStr('Currency')}
								onChange={handleChange}
							>
							{currencyOptions.map(currencyOption => (
								<MenuItem value={currencyOption.code} key={currencyOption.code}>
									{currencyOption.code}
									{!isMdApp && ` - ${currencyOption.name}`}
								</MenuItem>
							))

							}
							</Select>
						</FormControl>
						{selectedCurrencyCode !== businessCurrency && !isXsApp && (
							<Tooltip title={getStr('Prices_set_in_CURR_prices_may_vary_info', businessCurrency)}>
							<InfoIcon style={{ marginLeft: '15px' }} />
							</Tooltip>
						)}
					</Box>
				) : null
			}
		</>
	)
};

export default CurrencySelector;